import showToaster from '../../helpers/showToaster';
import history from '../../history';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';
import { updateDriver as mutation } from '../lib/graphql';

export function editDriver(id, firstName, lastName, email, password, phoneDialCode, phoneNumber, vehicleName, vehicleNumber, vehicleType, userStatus, isBan, phoneCountryCode) {
  return async (dispatch, getState, { client }) => {

    dispatch(setLoaderStart('EditDriver'));

    try {
      const { data } = await client.mutate({
        mutation,
        variables: {
          id,
          firstName,
          lastName,
          email,
          password,
          phoneDialCode,
          phoneNumber,
          vehicleName,
          vehicleNumber,
          vehicleType: Number(vehicleType),
          userStatus,
          isBan,
          phoneCountryCode
        }
      });

      dispatch(setLoaderComplete('EditDriver'));

      if (data?.updateDriver?.status === 200) {
        history.push('/siteadmin/drivers')
        showToaster({ messageId: 'driverUpdated', toasterType: 'success' })
      } else {
        showToaster({ messageId: 'somethingWentWrong', toasterType: 'error', requestContent: data?.updateDriver?.errorMessage })
      }

    } catch (error) {
      showToaster({ messageId: 'somethingWentWrong', toasterType: 'error', requestContent: error })
    }
  }
};
